const CJK = /[぀-ヿ㐀-鿿가-힯]/;

/**
 * Join first and last name for display.
 * CJK names are written family name first with no space (陳怡君),
 * other names keep "First Last".
 * @returns {string}
 */
export const formatPersonName = (firstName, lastName) => {
  const first = (firstName || "").trim();
  const last = (lastName || "").trim();
  if (CJK.test(first) || CJK.test(last)) return `${last}${first}`;
  return `${first} ${last}`.trim();
};

export default formatPersonName;
